import { render, staticRenderFns } from "./ImportProductByRent.vue?vue&type=template&id=0befc1d6&scoped=true&"
import script from "./ImportProductByRent.vue?vue&type=script&lang=js&"
export * from "./ImportProductByRent.vue?vue&type=script&lang=js&"
import style0 from "./ImportProductByRent.vue?vue&type=style&index=0&id=0befc1d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0befc1d6",
  null
  
)

export default component.exports